import React from 'react';
import PropTypes from 'prop-types';
import Button from '../button'; 

const PaymentHeader = ({ onAddNew }) => {
  return (
    <div className="new-transaction__header">
      <h2>Payment methods</h2>
      <Button
        color="transparent"
        className="button"
        xSize="xs"
        ySize="sm"
        onClick={onAddNew}
      >
        Add new
      </Button>
    </div>
  );
};

PaymentHeader.propTypes = {
  onAddNew: PropTypes.func.isRequired,
};

export default PaymentHeader;